






























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { Toast } from 'vant';
import { TbInventory } from '@/http';
import calculate from '@/common/util/calculate';
import { fmoney } from "@/common/util/money";
@Component({
    components: {
      
    },
})
export default class inventoryDetail extends Vue {
    public $refs: {
    };

    show=false;

    form:any={
        id:"",
        createTime:"",
        creatorName:"",
        details:[]
    };

    fmoney = fmoney

    loading = false;

    id="";

    get beforeInventoryTotal(){
        let val = 0;
        let arr = this.form.details.filter(v=>v.beforeInventory).map(v=>v.beforeInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    get actInventoryTotal(){
        let val = 0;
        let arr = this.form.details.filter(v=>v.actInventory).map(v=>v.actInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    get profitOrLossTotal(){
        let val = 0;
        let arr = this.form.details.filter(v=>v.profitOrLoss).map(v=>v.profitOrLoss);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    get amountTotal(){
        let val = 0;
        let arr = this.form.details.filter(v=>v.amount).map(v=>v.amount);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    userInfo:any={};

    created() {
    }
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));  
    }

    async init(){
        this.loading = true;
        try {
            let res = await TbInventory.GetTbInventoryById({
                id:this.id
            })
            this.form = res;
            this.loading = false;
        } catch (error) {
            this.loading = false;
        }
    }

    async showFun(id){
        this.id = id;
        await this.init();
        this.show = true;
    }

    closeFun(){
        this.resetFun();
        this.show = false;
    }

    resetFun(){
        this.form ={
            id:"",
            createTime:"",
            creatorName:"",
            details:[]
        }
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/inventoryDetail.vue